import React from 'react';
import Css from '@components/MobileListBox/MobileListBox.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const mobileListBox = props => {
  return (
    <div className={' w-100 '} key={props.box.id}>
      <div
        className={
          props.parentClassName !== undefined
            ? props.parentClassName + ' ' + Css.item
            : Css.item + ' p-3 pl-4'
        }
        onClick={props.click}
      >
        <span className={Css.title + ' lakes-bold'}>
          {props.box.title.replace('<br/>', '')}
        </span>
        {(props.hideNav === undefined || props.hideNav === false) &&
          (props.activeBoxId === props.box.id ? (
            <FontAwesomeIcon
              icon={['fas', 'minus']}
              className={'float-right mt-1'}
            />
          ) : (
            <FontAwesomeIcon
              icon={['fas', 'plus']}
              className={'float-right mt-1'}
            />
          ))}
      </div>
      <div
        className={
          props.activeBoxId === props.box.id
            ? props.className + ' pl-3 pr-3 pb-3 d-block'
            : 'd-none'
        }
      >
        {props.activeBoxId === props.box.id && props.box.content}
      </div>
    </div>
  );
};

export default mobileListBox;



// WEBPACK FOOTER //
// ./src/components/MobileListBox/MobileListBox.js